module.exports = __webpack_public_path__ + "static/media/video.eaeab7a5.svg";